// extracted by mini-css-extract-plugin
export default {"dropdown_main_container":"dropdown-animation_dropdown_main_container__eM9LE","has_submenu":"dropdown-animation_has_submenu__Fkx3T"};